import { render, staticRenderFns } from "./GasPriceCalculator.vue?vue&type=template&id=0339748c"
import script from "./GasPriceCalculator.vue?vue&type=script&lang=ts"
export * from "./GasPriceCalculator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports